import { UNAUTHORIZED, FORBIDDEN, NOT_FOUND } from "@/api/httpStatus";
import {
  FORBIDDEN as FORBIDDEN_PATH,
  NOT_FOUND as NOT_FOUND_PATH
} from "@/router/type";
import {
  authorizationGet,
  authorizationSave,
  authorizationDelete
} from "./local.users";
import { AUTH, REFRESH_TOKEN } from "./endpoints.api";
import { refreshToken } from "../users.api";

const presetHeader = httpClient => {
  let auth = authorizationGet();
  let token = auth && auth.accessToken ? auth.accessToken : "";
  httpClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  httpClient.defaults.headers.common["Content-Type"] = "application/json";
};

const requestInterceptor = config => {
  let auth = authorizationGet();
  if (auth && auth.accessToken) {
    config.headers.Authorization = `Bearer ${auth.accessToken}`;
  }
  return config;
};

const requestErrorInterceptor = error => {
  return Promise.reject(error);
};

const responseInterceptor = response => {
  return response;
};

const errorInterceptor = httpClient => {
  let subscribers = [];
  let isRefreshing = false;

  return function (error) {
    const {
      config,
      response: { status }
    } = error;

    const originalRequest = config;

    let url =
      config.baseURL.length > 1
        ? config.url.substr(config.baseURL.length - 1)
        : config.url;
    if (status === UNAUTHORIZED && ![AUTH, REFRESH_TOKEN].includes(url)) {
      if (!isRefreshing) {
        isRefreshing = true;

        let auth = authorizationGet();
        httpClient.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${auth.refreshToken}`;

        refreshToken(auth.refreshToken)
          .then(resp => {
            let auth = authorizationGet();
            auth.refreshToken = resp.data.refreshToken;
            auth.accessToken = resp.data.accessToken;
            auth.expiresIn = resp.data.expiresIn;
            authorizationSave(auth);

            httpClient.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${auth.accessToken}`;
            subscribers.filter(callback => callback(auth.accessToken));

            isRefreshing = false;
          })
          .catch(() => {
            authorizationDelete();
            subscribers = [];
            isRefreshing = false;
            window.location =
              window.location.protocol + "//" + window.location.host;
          });
      }

      const retryOriginalRequest = new Promise(resolve => {
        subscribers.push(newAccessToken => {
          originalRequest["Authorization"] = "Bearer " + newAccessToken;
          originalRequest.headers.Authorization = "Bearer " + newAccessToken;
          resolve(httpClient(originalRequest));
        });
      });
      return retryOriginalRequest;
    } else if (status === FORBIDDEN && config.url != AUTH) {
      window.location.pathname = FORBIDDEN_PATH;
      return;
    } else if (status === NOT_FOUND) {
      window.location.pathname = NOT_FOUND_PATH;
    }
    return Promise.reject(error);
  };
};

export {
  presetHeader,
  requestInterceptor,
  requestErrorInterceptor,
  responseInterceptor,
  errorInterceptor
};
